class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.page = 1;
    this.pageShowed = 1;
    this.firstLoad = true;
    this.cachedProducts = [];
    this.productShowed = 0;
    this.infinitScroll = false;
    this.isFetching = false;
    this.pendingFetchPage = null;
  }

  connectedCallback() {
    this.initGrid();
    this.init();
    this.getWidth();
  }

  initGrid() {
    const grid = document.querySelector('ul.product-grid');
    if (!grid) return;
    this.gridName = 'ul.product-grid';
    this.gridContainer = grid;
    if (!this.dataset.next) {
      document.getElementById('load-more-button')?.classList.add('d-none');
    }
  }

  init() {
    if (this.initialized) return;
    this.initialized = true;

    const loadMoreButton = document.getElementById('load-more-button');
    if (!loadMoreButton) return;
    loadMoreButton.addEventListener('click', () => this.handleClickButton());

    if (this.cachedProducts.length <= 20) {
      this.page++;
      this.fetchNextPage(this.page);
    }
  }

  handleClickButton() {
    const button = document.getElementById('load-more-button');
    if (!button) return;
    if (button.dataset.infinit === 'true' && !this.infinitScroll) {
      this.enableInfinitScroll();
      button.classList.add('d-none');
    }
    this.displayMoreItems();
  }

  enableInfinitScroll() {
    window.addEventListener('scroll', () => this.onScroll(), { passive: true });
    this.infinitScroll = true;
  }

  onScroll() {
    if (this.loadingMore) return;
    const threshold = window.innerWidth < 768 ? 1200 : 800;
    const footer = document.querySelector('footer');
    if (!footer) return;
    if (footer.getBoundingClientRect().top <= window.innerHeight + threshold) {
      this.displayMoreItems();
    }
  }

  displayMoreItems() {
    if (this.cachedProducts.length === 0 && !this.checkToEnd()) return;
    this.loadingMore = true;

    const isEnded = this.checkToEnd();
    const button = document.getElementById('load-more-button');

    if (isEnded && this.cachedProducts.length < 24) {
      button?.classList.add('d-none');
      this.loadingMore = false;
      return;
    }

    this.disableButton();
    this.productShowed += 24;
    this.pageShowed++;

    const itemsToDisplay = this.cachedProducts.splice(0, 24);
    itemsToDisplay.forEach(item => {
      this.gridContainer.insertAdjacentHTML('beforeend', item);
    });

    this.getWidth();
    this.enableButton();
    this.buildModal();
    this.checkButtons();
    this.reloadWishlist();
    this.loadingMore = false;

    if (this.cachedProducts.length <= 24 && !isEnded) {
      this.page++;
      this.fetchNextPage(this.page);
    }
  }

  fetchNextPage(pageNumber) {
    if (this.isFetching) {
      this.pendingFetchPage = pageNumber;
      return;
    }

    const shopUrl = this.dataset.shopUrl || '';
    const url = `${shopUrl}/${this.dataset.next}`;
    const parsedUrl = new URL(url);
    parsedUrl.searchParams.set('page', pageNumber);
    if (parsedUrl.searchParams.get('q')) {
      parsedUrl.searchParams.set('search', parsedUrl.searchParams.get('q'));
    }
    parsedUrl.searchParams.delete('phcursor');

    const isEnded = this.checkToEnd(pageNumber);
    if (isEnded || !this.dataset.next) {
      this._handleEndState();
      return;
    }

    this.isFetching = true;
    fetch(parsedUrl.href, { method: 'GET', headers: { 'Content-Type': 'text/html' } })
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const grid = doc.querySelector(this.gridName);
        if (grid) {
          const temp = document.createElement('div');
          temp.innerHTML = grid.innerHTML;
          this.cachedProducts.push(...Array.from(temp.children).map(el => el.outerHTML));
        }

        this.isFetching = false;

        const moreToFetch = this.pendingFetchPage !== null ||
          (this.cachedProducts.length < 60 && !this.checkToEnd(this.page + 1));

        if (this.firstLoad && (!moreToFetch || this.cachedProducts.length > 24)) {
          this._resolveFirstLoad();
        }

        if (this.pendingFetchPage !== null) {
          const pending = this.pendingFetchPage;
          this.pendingFetchPage = null;
          this.fetchNextPage(pending);
        } else if (this.cachedProducts.length < 60 && !this.checkToEnd(this.page + 1)) {
          this.page++;
          this.fetchNextPage(this.page);
        }
      })
      .catch(err => {
        this.isFetching = false;
        if (this.pendingFetchPage !== null) {
          const pending = this.pendingFetchPage;
          this.pendingFetchPage = null;
          this.fetchNextPage(pending);
        }
        console.error('InfiniteScroll fetch error:', err);
      });
  }

  _resolveFirstLoad() {
    if (!this.firstLoad) return;
    this.firstLoad = false;
    document.getElementById('big-spinner')?.classList.add('d-none');
    if (this.cachedProducts.length > 0) {
      document.getElementById('load-more-button')?.classList.remove('d-none');
    } else {
      this._handleEndState();
    }
  }

  _handleEndState() {
    document.getElementById('big-spinner')?.classList.add('d-none');

    if (this.cachedProducts.length > 0 && this.productShowed === 0) {
      // Petite collection : afficher directement les produits restants sans bouton
      this.displayMoreItems();
      document.getElementById('load-more-button')?.classList.add('d-none');
      document.getElementById('ProductCount')?.classList.add('d-none');
    } else if (this.cachedProducts.length === 0 && this.productShowed === 0) {
      document.getElementById('ProductCount')?.classList.add('d-none');
      if (this.dataset.next) {
        document.getElementById('no-items-available')?.classList.remove('d-none');
      }
    } else if (this.cachedProducts.length === 0) {
      // Tous les produits ont été affichés
      document.getElementById('load-more-button')?.classList.add('d-none');
    }
  }

  checkToEnd(pageNumber) {
    const bar = document.getElementById('chargedProductColored');
    if (!bar) return true;
    const p = pageNumber !== undefined ? pageNumber : this.page;
    return p * 24 >= parseInt(bar.dataset.max) + 24;
  }

  buildModal() {
    if (typeof mainAddToCart === 'function') mainAddToCart();
  }

  getWidth() {
    const bar = document.getElementById('chargedProductColored');
    if (!bar) return;
    const width = (this.pageShowed * 24) / Number(bar.dataset.max) * 100;
    bar.style.width = width + '%';
  }

  checkButtons() {
    document.querySelectorAll('.quick-add__add-to-cart').forEach(button => {
      button.addEventListener('click', () => {
        if (typeof initializeVariantCheck === 'function') initializeVariantCheck(button);
      });
    });
  }

  disableButton() {
    const button = document.getElementById('load-more-button');
    if (!button) return;
    button.disabled = true;
    button.classList.add('showSpinner');
  }

  enableButton() {
    const button = document.getElementById('load-more-button');
    if (!button) return;
    button.disabled = false;
    button.classList.remove('showSpinner');
  }

  wishlistCacheKey(customerId) {
    return customerId ? `kiabi_wishlist_${customerId}` : 'kiabi_wishlist_guest';
  }

  readWishlistCache(customerId) {
    try {
      const raw = localStorage.getItem(this.wishlistCacheKey(customerId));
      return raw ? JSON.parse(raw) : [];
    } catch (err) {
      return [];
    }
  }

  wishlistItemGid(item) {
    return typeof item === 'string' ? item : item.gid;
  }

  applyWishlistCache(customerId) {
    const cached = this.readWishlistCache(customerId).map((item) => this.wishlistItemGid(item));

    const pairs = new Map();
    document.querySelectorAll('.wishlist_fav[data-product-id]').forEach((el) => {
      const id = el.dataset.productId;
      if (!pairs.has(id)) pairs.set(id, {});
      pairs.get(id)[el.dataset.action] = el;
    });

    pairs.forEach((pair) => {
      if (!pair.add || !pair.remove) return;
      const gid = `gid://shopify/Product/${pair.add.dataset.productId}`;
      const inWishlist = cached.includes(gid);
      pair.add.style.display = inWishlist ? 'none' : 'block';
      pair.remove.style.display = inWishlist ? 'block' : 'none';
    });
  }

  writeWishlistCache(customerId, wishlist) {
    if (!Array.isArray(wishlist)) return;
    try {
      localStorage.setItem(this.wishlistCacheKey(customerId), JSON.stringify(wishlist));
    } catch (err) {
      // localStorage indisponible : on ignore silencieusement
    }
  }

  toggleGuestWishlistCache(element, action) {
    const productId = element.dataset.productId;
    const gid = `gid://shopify/Product/${productId}`;
    const list = this.readWishlistCache(null);

    const next = action === 'add'
      ? (list.some((item) => this.wishlistItemGid(item) === gid)
          ? list
          : [...list, {
              gid,
              title: element.dataset.productTitle || '',
              image: element.dataset.productImage || '',
              url: element.dataset.productUrl || '',
              price: element.dataset.productPrice || ''
            }])
      : list.filter((item) => this.wishlistItemGid(item) !== gid);

    this.writeWishlistCache(null, next);
  }

  // sessionStorage : le compteur repart de 0 à chaque nouvelle session (navigateur/onglet
  // fermé puis rouvert), mais survit à un simple refresh de la page.
  maybeShowWishlistGuestModal() {
    let count;
    try {
      count = parseInt(sessionStorage.getItem('kiabi_wishlist_guest_modal_count') || '0', 10) + 1;
      sessionStorage.setItem('kiabi_wishlist_guest_modal_count', String(count));
    } catch (err) {
      return; // sessionStorage indisponible : on ne relance pas la popup
    }

    // 1er ajout de la session, puis tous les 4 ajouts (5e, 9e, 13e...)
    if (count % 4 !== 1) return;

    const modal = document.getElementById('wishlistGuestModal');
    if (!modal) return;
    modal.hidden = false;
    document.body.classList.add('wishlist-guest-modal-open');
  }

  bindWishlistGuestModalDismiss() {
    const modal = document.getElementById('wishlistGuestModal');
    if (!modal || modal.dataset.bound === 'true') return;
    modal.dataset.bound = 'true';

    modal.querySelectorAll('[data-wishlist-guest-dismiss]').forEach((el) => {
      el.addEventListener('click', () => {
        modal.hidden = true;
        document.body.classList.remove('wishlist-guest-modal-open');
      });
    });
  }

  reloadWishlist() {
    const wishlistConfigEl = document.getElementById('wishlistConfig');
    if (!wishlistConfigEl) return;

    const customerId = wishlistConfigEl.dataset.customerId;
    this.applyWishlistCache(customerId);
    this.bindWishlistGuestModalDismiss();

    document.querySelectorAll('.wishlist_fav').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        const element = e.currentTarget;
        if (element.dataset.disabled === 'true') return;

        const other = element.parentElement?.querySelector(
          `.wishlist_fav[data-action="${element.dataset.action === 'add' ? 'remove' : 'add'}"]`
        );

        element.dataset.disabled = 'true';
        element.classList.add('is-loading');

        if (other) {
          other.dataset.disabled = 'true';
          other.classList.add('is-loading');
          element.style.display = 'none';
          other.style.display = 'block';
          other.classList.add('wishlist-pop');
          other.addEventListener('animationend', () => other.classList.remove('wishlist-pop'), { once: true });
        }

        if (!customerId) {
          this.toggleGuestWishlistCache(element, element.dataset.action);
          if (element.dataset.action === 'add') this.maybeShowWishlistGuestModal();
          element.dataset.disabled = 'false';
          element.classList.remove('is-loading');
          if (other) {
            other.dataset.disabled = 'false';
            other.classList.remove('is-loading');
          }
          return;
        }

        const body = {
          productId: element.dataset.productId,
          action: element.dataset.action
        };

        try {
          const r = await fetch(wishlistConfigEl.dataset.url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
          });

          if (r.ok) {
            const data = await r.json().catch(() => null);
            if (data && Array.isArray(data.wishlist)) {
              this.writeWishlistCache(customerId, data.wishlist);
            }
          } else if (other) {
            other.style.display = 'none';
            element.style.display = 'block';
          }
        } catch (err) {
          console.error(err);
          if (other) {
            other.style.display = 'none';
            element.style.display = 'block';
          }
        } finally {
          element.dataset.disabled = 'false';
          element.classList.remove('is-loading');
          if (other) {
            other.dataset.disabled = 'false';
            other.classList.remove('is-loading');
          }
          if (window.location.pathname.endsWith('/pages/wishlist')) {
            element.closest('.grid__item')?.remove();
            const grid = document.getElementById('product-grid');
            const emptyState = document.getElementById('wishlistEmptyState');
            if (grid && emptyState && grid.querySelectorAll('.grid__item').length === 0) {
              emptyState.style.display = '';
            }
          }
        }
      });
    });
  }
}

customElements.define('infinite-scroll', InfiniteScroll);
